// Only currently visible, button-bearing notices participate.
export function createActionableNoticeStore() {
  const entries = new Map(), listeners = new Set();
  const publish = () => listeners.forEach(listener => listener());
  return {
    subscribe(listener) { listeners.add(listener); return () => listeners.delete(listener); },
    latest(placement) { return [...entries].reverse().find(([, entry]) => entry.placement === placement)?.[0] || null; },
    add(id, entry) { entries.set(id, entry); publish(); },
    remove(id) { if (entries.delete(id)) publish(); },
    dismissAll(notify = true) { [...entries.values()].forEach(entry => { try { entry.dismiss(notify); } catch { /* One failed close must not keep other popups open. */ } }); },
  };
}
